import request from '@/utils/request'

// 会话管理API

// 分页查询会话列表
export function listConversations(params) {
  return request({
    url: '/api/admin/conversations',
    method: 'get',
    params
  })
}

// 获取会话详情
export function getConversation(conversationId) {
  return request({
    url: `/api/admin/conversations/${conversationId}`,
    method: 'get'
  })
}

// 获取会话消息列表
export function getConversationMessages(conversationId, params) {
  return request({
    url: `/api/admin/conversations/${conversationId}/messages`,
    method: 'get',
    params
  })
}

// 关闭会话
export function closeConversation(conversationId, data) {
  return request({
    url: `/api/admin/conversations/${conversationId}/close`,
    method: 'post',
    data
  })
}

// 转接会话
export function transferConversation(conversationId, data) {
  return request({
    url: `/api/admin/conversations/${conversationId}/transfer`,
    method: 'post',
    data
  })
}

// 获取会话统计数据
export function getConversationStatistics(params) {
  return request({
    url: '/api/admin/conversations/statistics',
    method: 'get',
    params
  })
}
